<template>
  <div class="content">
    <el-row class="content-line">
      <el-col :span="8" class="title">业务名称</el-col>
      <el-col :span="14" class="text">体检套餐</el-col>
    </el-row>
    <el-row class="content-line">
      <el-col :span="8" class="title">支付金额</el-col>
      <el-col :span="14" class="text" style="color: #409eff">￥{{$route.query.amount}}</el-col>
    </el-row>
    <div style="height: .8rem;color: #999999;line-height: .8rem;margin-left: .3rem;">
      请选择支付方式
    </div>
    <el-row class="content-line">
      <el-col :span="2" style="margin-left: .3rem;margin-top: .2rem">
        <img src="static/img/wechatpay.png" style="width: .4rem"/>
      </el-col>
      <el-col :span="8" class="title" style="margin-left: 0">微信公众号支付</el-col>
      <el-col :span="12" class="text" style="color: #409eff;font-size: .4rem"><i class="el-icon-success"></i></el-col>
    </el-row>
    <div style="width: 100%;text-align: center;margin-top: .6rem;">
      <el-button type="primary" style="width: 6rem;font-size: .32rem" @click="pay">立即支付</el-button>
    </div>
  </div>
</template>

<script>
  import {paybodycheck,paybodycheck_after} from '../../api/index'
  export default {
    data(){
      return{
        orderId:''
      }
    },
    created() {
      //修改标题
      document.title = '支付'
    },
    methods:{
      pay(){
        let patient = this.$storage.get('patient')
        let query = this.$route.query
        paybodycheck({
          order_id: this.orderId,
          amount: query.amount,
          clinic_card_num: patient.clinic_num,
          clinic_patient_name: patient.clinic_patient_name,
          prjid: query.prjid,
          // pay_status: 0,
          // pay_time: "2020-10-13T03:20:14.952Z",
          user_open_id: patient.open_id,
          // out_trade_no: "string",
          HealthCardId: patient.healthCardId,
          PatientId: patient.patient_id,
          // his_returncode: "string",
          // his_returnmsg: "string",
          // refund_status: "string",
          // transaction_id: "string"
        }).then(res=>{
          if(!res.IsSuccess){
            this.$message({
              message: res.Msg,
              type: 'error',
              duration:3000,
              center:true,
              offset:200
            });
          }else {
            //支付
            let wxJsonApiParam =  JSON.parse(res.Data.WxJsonData.wxJsonApiParam)
            this.orderId = res.Data.RecoredID
            let self = this
            function onBridgeReady() {
              WeixinJSBridge.invoke(
                'getBrandWCPayRequest', wxJsonApiParam,
                function(res) {
                  if(res.err_msg == "get_brand_wcpay_request:ok") {
                    self.$message({
                      message: '支付成功！',
                      type: 'success',
                      duration:3000,
                      center:true,
                      offset:200
                    });
                    // paybodycheck_after({
                    //   order_id: self.orderId,
                    //   paystatus: 1,
                    //   openid:self.$storage.get('openid')
                    // }).then(res=>{
                    //
                    // })
                    setTimeout(() => {
                      self.$router.push({path:'/payRecord',query:{index:2}})
                    }, 500)
                  }else {
                    self.$message({
                      message: '支付失败！',
                      type: 'error',
                      duration:3000,
                      center:true,
                      offset:200
                    });
                    // paybodycheck_after({
                    //   order_id: self.orderId,
                    //   paystatus: 2,
                    //   openid:self.$storage.get('openid')
                    // }).then(res=>{
                    //
                    // })
                  }
                }
              );
            }
            if(typeof WeixinJSBridge == "undefined") {
              if(document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
              } else if(document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
              }
            } else {
              onBridgeReady();
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    font-size: .28rem;
    background-color: #f4f4f4;
  }
  .content-line{
    height: .8rem;
    background-color: #FFFFFF;
    margin-bottom: 1px;
  }
  .title{
    line-height: .8rem;
    margin-left: .3rem;
    color: #666666;
  }
  .text{
    line-height: .8rem;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/medicalPlanPay.vue